'use client';
import Buttons from '@ui/buttons';
import { usePathname } from 'next/navigation';

export default function AuthBanner() {
	const pathname = usePathname();

	// List of URLs that should not show the Auth Banner
	const excludedPaths = [
		'/login/',
		'/register/',
		'/password/',
		'/login-required/',
		'/help-center/'
	];

	// Check if the pathname matches any excluded paths or starts with /help-center/
	const shouldHideBanner =
		excludedPaths.includes(pathname) || pathname.startsWith('/help-center/');

	return (
		!shouldHideBanner && (
			<div
				className={`flex flex-col items-center justify-center bg-[#4040C7] p-6 sm:p-8 pb-8 sm:pb-10 text-white shadow-black/50 shadow-lg relative z-10`}>
				<div
					className={`flex flex-col sm:flex-row sm:items-center justify-center gap-6 sm:gap-16 w-full max-w-screen-lg relative`}>
					<div className={`flex flex-col gap-2 flex-1 text-center`}>
						<span className={`text-xs sm:!text-[13px] md:text-lg`}>
							To gain access to the content, register today!
						</span>
						<Buttons.Quaternary className={''} href={`/register`}>
							Create Your Account
						</Buttons.Quaternary>
					</div>
					<div
						className={`h-[1px] sm:h-[120%] w-auto mt-4 sm:mt-auto sm:w-[1px] flex static sm:absolute bg-white/20 sm:top-0`}></div>
					<div className={`flex flex-col gap-2 flex-1 text-center`}>
						<span className={`text-xs sm:!text-[13px] md:text-lg`}>
							Already a member?
						</span>
						<Buttons.Primary className={''} href={`/login`}>
							Log In
						</Buttons.Primary>
					</div>
				</div>
			</div>
		)
	);
}
